var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBooks = function SvgIconBooks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.984,
    height: 15.357,
    viewBox: "0 0 21.984 15.357",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.051,8.571H3.211a.642.642,0,0,0-.64.64V23.288a.642.642,0,0,0,.64.64H7.051a.642.642,0,0,0,.64-.64V9.211A.642.642,0,0,0,7.051,8.571Zm-.64,3.839H3.851v-1.28H6.411v1.28Zm7.039-3.839H9.61a.642.642,0,0,0-.64.64V23.288a.642.642,0,0,0,.64.64h3.839a.642.642,0,0,0,.64-.64V9.211A.642.642,0,0,0,13.449,8.571Zm-.64,3.839H10.25v-1.28h2.559Zm5.061-2.85-3.429,1.728a.642.642,0,0,0-.284.859l5.758,11.429a.642.642,0,0,0,.859.284L24.2,22.132a.642.642,0,0,0,.284-.859L18.729,9.844a.642.642,0,0,0-.859-.284Zm3.258,13.728a.64.64,0,1,1-.64-.64A.64.64,0,0,1,21.128,23.288Z",
    transform: "translate(-2.571 -8.571)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBooks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-books.d9ff2185.svg";
export { ForwardRef as ReactComponent };